<template lang='pug'>
.content.notify-content
  .row.notify-body
    .col-md-12
      .header
        .title-notify Danh sách thông báo
        .check-all(@click='onCheckAll')
          img(src="../../assets/images/faces/done_all.svg")
          span Đánh dấu tất cả là đã xem
      .col-md-12.box-notify
        div(v-for="(item, index) in lstNotify")
          .card(:style="item.status === 2 ? 'background:#FBF4D2;' : ''")
            .box-notify-items(@click="onNotifyItem(item.id)")
              .img-avt
                img(src="../../assets/images/faces/ic_AvatarDefault.svg")
              .content-notify
                //- | Bạn có yêu cầu liên kết tài khoản mới từ Nguyễn Ngọc Lan
                | {{ item.short_content }}
                .date {{ item.created_at | moment }}
        //- Loading(:isOpacity="1" v-if="lstNotify && lstNotify.length === 0")
        //- observer(@intersect="onIntersected")
</template>

<script>
import Observer from '../Point/Observer'
import moment from 'moment'
import graphql from '../Model/graphql'
import gql from 'graphql-tag'
import MdNotification from '@/core/components/mdNotification'
import Loading from '../../components/Front/Loading'
export default {
  components: {
    MdNotification,
    Observer,
    Loading
  },
  data() {
    return {
      lstNotify: [],
      offset: 10,
      limit: 10,
      items: [],
      intervalid: null
    }
  },
  methods: {
    showNotification(messages, color, from, align, timeout) {
      this.$notifications.notify({
        'type': color,
        'icon': 'notifications',
        'message': messages,
        'placement': {
          'from': from,
          'align': align
        },
        'timeout': timeout
      })
    },
    onCheckAll() {
      if (this.lstNotify && this.lstNotify.length > 0) {
        // console.log('check all')
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_READ_NOTIFY),
          variables: {
            uid: this.$store.getters.user,
            changes: {
              status: 3
            }
          }
        }).then(res => {
          this.refresh()
          this.showNotification('Thông báo của bạn đã được cập nhật', 'success', 'top', 'right', 5000)
        }).catch(e => {
          this.showNotification(e, 'danger', 'top', 'right', 5000)
        })
      }
    },
    refresh(offset, limit) {
      this.$apollo.query({
        query: gql(graphql.GET_NOTIFY_USER),
        variables: {
          uid: this.$store.getters.user,
          offset: offset,
          limit: limit
        }
      }).then((response) => {
        this.lstNotify = response.data.user_notification
      })
    },
    onNotifyItem(id) {
      // console.log('read item ', id)
      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_READ_NOTIFY),
        variables: {
          id: id,
          changes: {
            status: 3
          }
        }
      }).then(data => {
        this.refresh()
      })
    }
    // async getNotification(offset, limit) {
    //   await this.$apollo.query({
    //     query: gql(graphql.GET_NOTIFY_USER),
    //     variables: {
    //       uid: this.$store.getters.user,
    //       offset: offset,
    //       limit: limit
    //     }
    //   }).then(async(res) => {
    //     if (res) {
    //       // console.log(res.data.user_notification)
    //       this.items = await res.data.user_notification
    //     }
    //   })
    // },
    // async onIntersected() {
    //   // console.log(this.offset, this.limit)
    //   await this.getNotification(this.offset, this.limit)
    //   this.offset += 10
    //   this.lstNotify = [...this.lstNotify, ...this.items]
    // }
  },
  filters: {
    moment(date) {
      return moment(date).format('hh:mm DD/MM/YYYY') // format (h:mm:ss a)
    }
  },
  apollo: {
    // lstNotify: {
    //   query: gql(graphql.GET_NOTIFY_USER),
    //   variables() {
    //     return {
    //       uid: this.$store.getters.user,
    //       offset: 0,
    //       limit: 10
    //     }
    //   },
    //   update: data => data.user_notification
    // }
  },
  beforeDestroy() {
    // console.log('DESTROYYYY!!!', this.intervalid)
    clearInterval(this.intervalid)
  },
  created() {
    this.$store.commit('setIsHomePage', false)
    this.intervalid = setInterval(() => {
      this.refresh(0, 10)
    }, 500)
  }
}
</script>

<style lang="scss">
.notify-content {
  padding-top: 20px !important;
}
.notify-body {
  .header {
    position: relative;
    .title-notify {
        font-size: 24px;
        font-weight: bold;
        text-align: left;
        color: #5F6468;
    }
    .check-all {
      position: absolute;
      top: 0px;
      right: 0px;
      cursor: pointer;
      img {width: 24px;}
      span {color: #9F6A28; padding-left: 10px; font-size: 13px;}
    }
  }
  .box-notify {
    padding-left: 0px;
    padding-right: 0px;
    div {
      .card {
        margin-top: 15px;
        margin-bottom: 0px;
        border-radius: 5px;
        .box-notify-items {
            margin: 15px;
            .img-avt {
                width: 40px;
                display: inline-flex;
                float: left;
                img {max-width: 100%; height: auto; width: 100%; border-radius: 50%;}
            }
            .content-notify {
                padding-left: 15px;
                display: inline-block;
                width: calc(100% - 40px);
                font-weight: bold;
                text-align: justify;
                font-size: 15px;
                .date {color: #BEBEBE; font-weight: normal;padding-top: 5px;font-size: 13px;}
            }
        }
      }
    }
  }
}

@media (max-width: 414px) {
  .notify-content {
    padding-top: 30px !important;
    .notify-body {
      .header {
        .title-notify {}
        .check-all {
          span {display: none;}
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?fbcebf00